import { render, staticRenderFns } from "./trawl-input.vue?vue&type=template&id=5285dc96"
import script from "./trawl-input.vue?vue&type=script&lang=js"
export * from "./trawl-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports